import { connect } from 'react-redux'
import get from 'lodash/get'

import WorkSummaryWorkOrderDetails from '../../components/work-summaries/work-summary-work-order-details'

import { fetchWorkOrder, downloadCSV, sendReceiptEmail } from '../../actions/work-orders'
import { loadServicingsForWorkOrder, approveRemainingServicings } from '../../actions/servicings'

function mapStateToProps (state, ownProps) {
  const workOrder = get (state.workOrders, ownProps.workOrderId, {} )
  const locationModel = get(state.locations, workOrder.location, {} )
  const userType = get(state.auth, 'session.type')

  let signedOff = false

  if (!workOrder) return {}

  signedOff = workOrder.status === 'signed_off'

  return {
    workOrder,
    locationModel,
    signedOff,
    userType
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.workOrderId

  dispatch(fetchWorkOrder(id))

  return {
    csvDownload () {
      dispatch(downloadCSV(id))
    },

    approveRemaining () {
      dispatch(approveRemainingServicings(id))
        .then(() => dispatch(fetchWorkOrder(id)))
        .then(() => dispatch(loadServicingsForWorkOrder(id, 'finished', false)))
    },

    sendReceiptEmail (recipients) {
      return dispatch(sendReceiptEmail(id, { recipients }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkSummaryWorkOrderDetails)



// WEBPACK FOOTER //
// ./src/containers/work-summaries/work-summary-work-order-details-container.js